import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { getUser, updateUser } from '../../actions/adminActions';
import { required, alphaNumeric, numbersOnly, isdecimal } from "../validations";
import { renderFieldWithShake, renderCountrySelectField, renderFieldCheckbox, renderStatusSelectField, renderPhoneField } from '../../utils/renderFields';
import TransactionsTable from './transactionsTable';
import MatchHistoryTable from './matchHistoryTable';
import Promotion from './promotion';
import '../additional.css';

var panelStyle = { paddingLeft: '20px', paddingRight: '20px' }

class User extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {
        // calling the new action creator

        if (this.props.match.params.userId) {
            console.log("UserId:" + this.props.match.params.userId);
            this.props.localGetUser(this.props.match.params.userId);
        }

    }

    handleFormSubmit(values) {
        console.log("handeling user submit")
        console.log(values);
        if (this.props.valid) {

            values.hcp = values.hcp !== undefined ? (values.hcp + '').replace(/,/g, '.') : undefined; 

            this.props.localUpdateUser(values);
        }
    }

    render() {
        const { user, handleSubmit, pristine, reset, submitting, valid, working, playerStatusValue } = this.props;
        
        if (user === null)
            return (
                <div className="container-fluid">
                    <h2 className="panel-title">Loading...</h2>
                </div>
                );

        return (
            <div>
            <div className="container-fluid">
                    <h2 className="panel-title">User: #{user.id} {user.firstName} {user.lastName}</h2>

           
                <div className="panel mini">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 text-center">
                                <h4 className="panel-title">Amount</h4>
                                <h2 className="current-position">{user !== null ? user.amount : ''}</h2>
                            </div>
                            <div className="col-lg-3 text-center">
                                <h4 className="panel-title">Played challenges</h4>
                                    <h2 className="current-position">{user.statistics.challengesPlayedCount}</h2>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-9">
                        <div className="panel settings-form" style={panelStyle}>
                            <form id="login-form" method="post" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <Field
                                            name="firstName"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="First name"
                                            placeholder="Enter your first name"
                                            validate={[required, alphaNumeric]}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <Field
                                            name="lastName"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="Last name"
                                            placeholder="Enter your last name"
                                            validate={[required, alphaNumeric]}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <Field
                                            name="address1"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="Address 1"
                                            placeholder="Enter your address of residence"
                                            validate={[alphaNumeric]}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <Field
                                            name="address2"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="Address 2"
                                            placeholder="Enter your address of residence"
                                            validate={[alphaNumeric]}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <Field
                                            name="zip"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="Postal/zip code"
                                            placeholder="Confirm your postal/zip code"
                                            validate={[numbersOnly]}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <Field
                                            name="city"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="City"
                                            placeholder="Enter your city of residence"
                                            validate={[alphaNumeric]}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <Field
                                            name="state"
                                            type="text"
                                            component={renderFieldWithShake}
                                            label="State"
                                            placeholder="Enter your state of residence"
                                            validate={[alphaNumeric]}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <Field
                                            name="countryIso"
                                            component={renderCountrySelectField}
                                            label="Country"
                                            placeholder="Enter your country of residence"
                                            validate={[required]}
                                        />
                                    </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Field
                                                name="phoneNumber"
                                                component={renderPhoneField}
                                                label="Phone"
                                                placeholder="Enter your phone number"
                                                validate={[required]}
                                            />
                                        </div>
                                        {/*
                                        <div className="col-md-6">

                                            <Field
                                                name="region"
                                                label="Display Challenges from region"
                                                type="text"
                                                component={renderRegionSelectField}
                                                placeholder="Select challenge region"
                                                validate={[required]} />
                                        </div>
                                       */}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">

                                            <Field
                                                name="playerStatus"
                                                label="Status"
                                                type="text"
                                                component={renderStatusSelectField}
                                                placeholder="Select status"
                                                validate={[required]} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            {playerStatusValue !== undefined && playerStatusValue === 'AMATURE' ?

                                                <Field
                                                    name="hcp"
                                                    type="text"
                                                    component={renderFieldWithShake}
                                                    label="Handicap"
                                                    placeholder="Enter your handicap"
                                                    validate={[required, isdecimal]}
                                                />

                                                : null

                                            }
                                        </div>
                                        <div className="col-md-6">
                                            {playerStatusValue !== undefined && playerStatusValue === 'AMATURE' ?
                                                <Field
                                                    name="nationalGolfId"
                                                    type="text"
                                                    component={renderFieldWithShake}
                                                    label="National  Golf Id"
                                                    placeholder="Enter your golf id"
                                                    validate={[required]}
                                                />
                                                : null

                                            }
                                        </div>
                                    </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <Field
                                            id="influenserCheckboxInput"
                                            name="influenser"
                                            type="checkbox"
                                            component={renderFieldCheckbox}
                                            label="Streamer"
                                            disabled={false}
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <Field
                                            id="bannedCheckboxInput"
                                            name="banned"
                                            type="checkbox"
                                            component={renderFieldCheckbox}
                                            label="Banned"
                                            disabled={false}
                                            placeholder=""
                                            />
                                     </div>
                               </div>


                                <button type="submit" className={'button success' + (!valid || pristine || submitting ? ' disabledBtn' : '')} name="button" disabled={!valid || pristine || submitting}>
                                    {working ? 'Working...' : 'SAVE'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <br />
                <h2 className="panel-title">Bonus</h2>
                <div className="panel" style={panelStyle}>
                    <Promotion user={user} />
                </div>
            </div>
            <div className="container-fluid">
                <br />
                <h2 className="panel-title">Transactions</h2>
                <div className="panel" style={panelStyle}>
                    <TransactionsTable transactions={user.transactions} />
                </div>
            </div>
            <div className="container-fluid">
                <br />
                <h2 className="panel-title">Match history</h2>
                <div className="panel" style={panelStyle}>
                    <MatchHistoryTable matches={user.matches} />
                </div>
            </div>
         </div>
        );
    }
}


function mapStateToProps(state) {
    const selector = formValueSelector('UserForm');
    const playerStatusValue = selector(state, 'playerStatus');

    const { working, type, message } = state.userReducer;
    const initialValues = state.adminReducer.user;
    const user = state.adminReducer.user;
    return {
        user, initialValues, working, type, message, playerStatusValue
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //function
        localGetUser: (id) => dispatch(getUser(id)),
        localUpdateUser: (values) => dispatch(updateUser(values)),
    };
}


User = reduxForm({
    form: 'UserForm', enableReinitialize: true
})(User);

User = connect(mapStateToProps, mapDispatchToProps)(User);

export default User; 
